import styled from 'styled-components';

export const Card = styled.div`
  padding: 20px;
  border-radius: 4px;
`;

export const ContainerTI = styled.div`
  display: flex;
  flex-direction: column;

  .ti {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.45);
  }
`;

export const Quantity = styled.div`
  font-family: 'Roboto';
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    font-size: 30px;
    line-height: 40px;
    margin: 0;
    padding: 0;

    & + p {
      font-size: 14px;
    }
  }
`;

export const Graphic = styled.div`
  width: 100%;
  height: 120px;
`;
